import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Rotate360 } from '../../../utils/animations';
import Icon from '../Icon';

export const StyleError = styled.div`
  text-align: center;
`;

export const StyleErrorText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('15px')};
  margin: ${rem('2px')} 0;
`;

export const StyleUploadText = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('12px')};
  ${props =>
    props.color &&
    css`
      color: ${props.color === 'dark'
        ? props.theme.colors.dark
        : props.theme.colors.light};
    `}
`;

export const IconAnimated = styled(Icon)`
  animation: ${Rotate360} 2s linear infinite;
  margin: ${rem('15px')} 0 ${rem('10px')};
`;
